import React, { ReactNode } from 'react';

type HeaderWrapperProps = {
  children: ReactNode;
  className?: string;
};

export const HeaderWrapper = ({ children, className = '' }: HeaderWrapperProps) => {
  return (
    <header className={`w-full border-b py-3 lg:px-8 px-6 flex items-center justify-between sticky top-0 bg-white z-50 ${className}`}>
      {children}
    </header>
  );
};
